(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Seccion__dl-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-lazy-video]').forEach(function (frame) {
    var id = frame.id.replace('DlVideoFrame-', '');
    var tpl = document.getElementById('DlVideoTpl-' + id);
    if (!tpl) return;

    function load() {
      frame.appendChild(tpl.content.cloneNode(true));
    }

    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          load();
          observer.disconnect();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0 });

    observer.observe(frame);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section__darshan-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.bm-pop-overlay[data-key]').forEach(function (overlay) {
    var KEY = overlay.dataset.key;
    var DELAY = parseInt(overlay.dataset.delay, 10) || 1500;
    var DURATION = overlay.dataset.duration || 'permanent';
    var id = overlay.id.replace('bmPopOverlay-', '');

    var pop = document.getElementById('bmPop-' + id);
    var btnClose = document.getElementById('bmPopClose-' + id);
    var btnDismiss = document.getElementById('bmPopDismiss-' + id);
    var btnCta = document.getElementById('bmPopCta-' + id);

    if (!pop) return;

    function isDismissed() {
      if (DURATION === 'pageload') return false;
      if (DURATION === 'session') {
        return !!sessionStorage.getItem(KEY);
      }
      try {
        var val = localStorage.getItem(KEY);
        if (!val) return false;
        if (val === 'permanent') return true;
        return Date.now() < parseInt(val, 10);
      } catch (e) { return false; }
    }

    function setDismissed() {
      if (DURATION === 'pageload') return;
      try {
        if (DURATION === 'session') {
          sessionStorage.setItem(KEY, '1');
          return;
        }
        if (DURATION === 'permanent') {
          localStorage.setItem(KEY, 'permanent');
          return;
        }
        var days = { '1day': 1, '7days': 7, '30days': 30 }[DURATION] || 30;
        localStorage.setItem(KEY, (Date.now() + days * 86400000).toString());
      } catch (e) {}
    }

    function open() {
      overlay.classList.add('is-open');
      pop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      pop.focus();
    }

    function close(dismiss) {
      overlay.classList.remove('is-open');
      pop.classList.remove('is-open');
      document.body.style.overflow = '';
      if (dismiss) setDismissed();
    }

    overlay.addEventListener('click', function () { close(true); });
    if (btnClose) btnClose.addEventListener('click', function () { close(true); });
    if (btnDismiss) btnDismiss.addEventListener('click', function () { close(true); });
    if (btnCta) btnCta.addEventListener('click', function () { close(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close(true);
    });

    if (!isDismissed()) {
      setTimeout(open, DELAY);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
